var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReceipt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#494B4C;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Receipt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,18h7v1H8V18z M12,12h-1c-0.5,0-1-0.7-1-1.2H9c0,1.2,0.9,2.1,2,2.2v1h1v-1c1.1,0,2-0.9,2-2s-0.9-2-2-2h-1 c-0.6,0-1-0.4-1-1s0.4-1,1-1h1c0.5,0,0.9,0.3,1,0.8c0,0,0,0,0,0.1h1c0-1-0.9-1.9-1.9-1.9c0,0-0.1,0-0.1,0V5h-1v1C9.9,6,9,6.9,9,8 s0.9,2,2,2h1c0.6,0,1,0.4,1,1S12.6,12,12,12z M23,21v1c0,1.7-1.3,3-3,3H6c-0.1,0-0.2,0-0.3,0c-1.6-0.1-2.8-1.4-2.7-3V0.2l2.5,1.9 l2-1.9l2,1.9l2-1.9l2,1.9l2-1.9l2,1.9L20,0.2V21H23z M8,21h11V2.2l-1.5,1.2l-2-1.9l-2,1.9l-2-1.9l-2,1.9l-2-1.9l-2,1.9L4,2.2V22 c0,0.1,0,0.2,0,0.2c0.1,1,1,1.8,2,1.8c1.1,0,2-0.9,2-2V21z M22,22H9c0,0.7-0.3,1.5-0.8,2H20C21.1,24,22,23.1,22,22z M7,17h9v-1H7V17 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceipt);
export default __webpack_public_path__ + "static/media/icon-receipt.39c976926084cc722ef7dbb692fd8a0e.svg";
export { ForwardRef as ReactComponent };